import api from './api';
import { endpoints, apiCall } from '../config/api';

export const landingPageService = {
  // Get all landing page content
  getAllContent: async () => {
    try {
      const response = await api.get(endpoints.landingPage);
      return response;
    } catch (error) {
      console.error('Error fetching landing page content:', error);
      throw error;
    }
  },

  // Get specific content type
  getContentByType: async (type) => {
    try {
      const response = await api.get(endpoints.contentByType(type));
      return response;
    } catch (error) {
      console.error(`Error fetching ${type} content:`, error);
      throw error;
    }
  },

  // Subscribe to newsletter - using enhanced apiCall
  subscribeNewsletter: async (email) => {
    try {
      const response = await apiCall(endpoints.newsletterSubscribe, {
        method: 'POST',
        data: { email }
      });
      return response;
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      throw error;
    }
  },

  // Contact form submission - using enhanced apiCall
  submitContact: async (formData) => {
    try {
      const response = await apiCall(endpoints.contact, {
        method: 'POST',
        data: formData
      });
      return response;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  }
};

export default landingPageService;